<template>
  <div class="fullBox">
    <div class="tableBox">
      <tableOne :tableList="tableList" @changeSubmit="changeSubmit" />
    </div>
  </div>
</template>

<script>
import tableOne from "./components/inventoryTable.vue";
import apis from "@/apis/borrowingAnUmbrella";
export default {
  name: "inventory",
  components: {
    tableOne,
  },
  data() {
    return {
      tableList:[]
    };
  },
  mounted() {
    this.getList()
  },
  methods: {
    changeSubmit() {
      this.getList()
    },
    //获取数据列表
    getList() {
      apis.stockList().then((res) => {
        if (res.code == 200) {
          this.tableList = res.data;
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
$zoom: 1020 / 375;
.fullBox {
  width: 100%;
  height: 100%;
  font-size: 11px * $zoom;
  position: relative;
  overflow: hidden;
  padding: 40px;
  background: #fff;
  border-radius: 40px;
}
.tableBox {
  // padding: 20px 20px 0;
  ::v-deep {
    thead {
      tr {
        th {
          background: #fafafa;
          height: 100px;
        }
      }
    }
    tbody {
      tr {
        td {
          background: #fff;
          height: 140px;
          .cell {
            display: flex;
            align-items: center;
            justify-content: center;
          }
        }
      }
      .tag {
        width: 60%;
        padding: 10px 10px;
        color: #fe964a;
        background: #fff0e6;
        border-radius: 10px;
      }
    }
    .el-table--mini .el-table__cell {
      padding: 0 !important;
    }
  }
}
</style>
